import './App.css';
import React, { useEffect, useState } from 'react';
import { ToastContainer } from 'react-toastify';
import Loader from './Loader';
import 'react-toastify/dist/ReactToastify.css';
import AppRoutes from './routes/AppRoutes';
import MaintenancePageFallBack from './MaintenancePageFallBack';
import instance from './axios';
import './styles/main.css';
// App.jsx
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import VersionUpdatePopup from './components/Layouts/VersionUpdatePopup';

function App() {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);

  useEffect(() => {
    const checkHealth = async () => {
      try {
        const response = await instance.get('api/app/healthcheck');
        if (response.data?.status) {
          setIsMaintenanceMode(false);
          sessionStorage.removeItem('maintenanceMode');
        }
      } catch (error) {
        if (error?.response?.status === 503) {
          setIsMaintenanceMode(true);
          sessionStorage.setItem('maintenanceMode', 'true');
        }
      }
    };
    checkHealth();
  }, []);

  return (
    <div className="App">
      <Loader />
      {isMaintenanceMode ? (
        <MaintenancePageFallBack />
      ) : (
        <>
          <AppRoutes />
          <VersionUpdatePopup />
        </>
      )}
      <ToastContainer />
    </div>
  );
}

export default App;
